























import { Component, Emit, Model, Prop, Vue } from "vue-property-decorator";
import {RegionStore} from "@/modules/regions/store"; // giả sử có api

@Component({
  name: "FreightFeeCodes"
})
export default class FreightFeeCodes extends Vue {
  @Prop({ type: Boolean, default: false }) readonly disabled!: boolean;
  @Prop({ type: String, default: "Chọn mã phí" }) readonly placeholder!: string;
  @Prop({ default: "default" }) readonly size!: "default" | "small" | "large";

  // v-model
  @Model("change", { type: String })
  readonly modelValue!: string;

  items: string[] = [];

  /** emit ra parent mỗi khi chọn xong */
  @Emit("change")
  handleChange(value?: string) {
    return value;
  }

  /** Search filter */
  filterOption(input: string, option: any) {
    const text = option.componentOptions.children[0].text;
    return text.toLowerCase().includes(input.toLowerCase());
  }

  /** Khi mounted load list data từ API */
  async mounted() {
    try {
      this.items = await RegionStore.getFreightFeeCodes();
    } catch (e) {
      this.$message.error("Lấy danh sách mã tính cước thất bại");
    }
  }
}
